<youtube-player
      [playerVars]="playerConfig"
      [width]=300
      [height]=350
      [videoId]="videoId"
      (ready)="onReady($event)"
></youtube-player>